module.exports = __webpack_public_path__ + "static/media/Литвинов В.Л. Литвинова К.В..cba74ac2.pdf";